import { CustomerSchema } from "@redotech/redo-model/customer";
import { CustomerFilterSchema } from "@redotech/redo-model/customer-filter";
import * as z from "zod/v4";

export const getCustomersByEventData = {
  name: "getCustomersByEventData" as const,
  input: z.object({
    filters: CustomerFilterSchema,
    limit: z.number().min(1).max(1000),
  }),
  output: z.object({ data: z.array(CustomerSchema), totalCount: z.number() }),
};
